module.exports = __webpack_public_path__ + "static/media/physio-swiss-logo-bw.49594927.jpg";